import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProviderForm } from '../../../features/payment-providers/components/provider-form';
import { useCreateProvider } from '../../../features/payment-providers/mutations';

export const Route = createFileRoute('/_authenticated/payment-providers/new')({
  staticData: { breadcrumb: 'Новый' },
  component: NewProviderPage,
});

function NewProviderPage() {
  const navigate = useNavigate();
  const create = useCreateProvider();
  return (
    <div className="max-w-lg space-y-4 p-4">
      <h1 className="text-xl font-bold">Новый провайдер</h1>
      <ProviderForm
        pending={create.isPending}
        onSubmit={(values) =>
          create.mutate(values, { onSuccess: () => navigate({ to: '/payment-providers' }) })
        }
      />
    </div>
  );
}
